import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
import StorageCostVconsole17Upthere from './components/StorageCostVconsole17Upthere.vue'

declareVconsoleComponent('storageCostVconsole17Upthere', StorageCostVconsole17Upthere, 'vstorage_cost:vconsole17:upthere')
